import { render } from "./Order.vue?vue&type=template&id=2fbeca3d&scoped=true&ts=true"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"

import "./Order.vue?vue&type=style&index=0&id=2fbeca3d&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbeca3d"]])

export default __exports__